<template>
  <div class="vx-col w-full">
    <div class="vx-row">
      <div class="vx-col w-1/6">
        <label v-if="dropdownLabel" class="vs-input--label">{{
          dropdownLabel
        }}</label>
        <v-select
          class="w-full"
          :clearable="false"
          v-model="primary_dropdown_local"
          placeholder="Select"
          :options="options"
          v-validate="`${primarySelectValidationType}`"
          :name="`${validationName}.${id}.${primarySelectValidationName}`"
        />
        <validation-message
          v-show="
            vErrors.has(
              `${validationName}.${id}.${primarySelectValidationName}`
            )
          "
        >
          {{
            hideFieldName(
              `${validationName}.${id}.${primarySelectValidationName}`
            )
          }}
        </validation-message>
      </div>

      <div v-if="!secondarySelectOptions.length" class="vx-col w-1/4">
        <label v-if="primaryInputLabel" class="vs-input--label">{{
          primaryInputLabel
        }}</label>
        <vs-input
          key="primary-input"
          class="w-full"
          placeholder=" "
          v-model="data_local.value"
          :name="`${validationName}.${id}.${primaryInputValidationName}`"
          v-validate="`required|${validationType}`"
        />
        <validation-message
          v-show="
            vErrors.has(`${validationName}.${id}.${primaryInputValidationName}`)
          "
        >
          {{
            hideFieldName(
              `${validationName}.${id}.${primaryInputValidationName}`
            )
          }}
        </validation-message>
      </div>

      <div v-if="secondarySelectOptions.length" class="vx-col pl-0 w-1/4">
        <label v-if="secondarySelectLabel" class="vs-input--label">{{
          secondarySelectLabel
        }}</label>
        <!-- This does not work as it should -->
        <v-select
          class="w-full"
          :clearable="false"
          v-model="secondary_dropdown_local"
          placeholder="Select"
          :options="secondarySelectOptions"
          v-validate="`${secondarySelectValidationType}`"
          :name="`${validationName}.${id}.${secondarySelectValidationName}`"
        >
          <template v-slot:option="option">
            <div v-html="option.label"></div>
          </template>
          <template v-slot:selected-option="option">
            <div v-html="option.label"></div>
          </template>
        </v-select>
        <validation-message
          v-show="
            vErrors.has(
              `${validationName}.${id}.${secondarySelectValidationName}`
            )
          "
        >
          {{
            hideFieldName(
              `${validationName}.${id}.${secondarySelectValidationName}`
            )
          }}
        </validation-message>
      </div>

      <div v-if="secondarySelectOptions.length" class="vx-col pl-0 w-1/5">
        <label v-if="secondaryInputLabel" class="vs-input--label">{{
          secondaryInputLabel
        }}</label>
        <vs-input
          key="secondary-input"
          class="w-full"
          placeholder=" "
          v-model="data_local.value"
          :name="`${validationName}.${id}.${secondaryInputValidationName}`"
          v-validate="`required|${secondaryInputValidationType}`"
        />
        <validation-message
          v-show="
            vErrors.has(
              `${validationName}.${id}.${secondaryInputValidationName}`
            )
          "
        >
          {{
            hideFieldName(
              `${validationName}.${id}.${secondaryInputValidationName}`
            )
          }}
        </validation-message>
      </div>

      <div v-if="additionalInput" class="vx-col pl-0 w-2/12">
        <label v-if="additionalInputLabel" class="vs-input--label">{{
          additionalInputLabel
        }}</label>
        <vs-input
          key="additional-input"
          class="w-full"
          placeholder=" "
          v-model="data_local.additionalInputValue"
          :name="`${validationName}.${id}.${additionalInputValidationName}`"
          v-validate="additionalInputValidationType"
        />
        <validation-message
          v-show="
            vErrors.has(
              `${validationName}.${id}.${additionalInputValidationName}`
            )
          "
        >
          {{
            hideFieldName(
              `${validationName}.${id}.${additionalInputValidationName}`
            )
          }}
        </validation-message>
      </div>

      <div class="vx-col w-2/12 relative action-buttons">
        <label v-if="actionsLabel" class="vs-input--label"></label>
        <div class="vx-row">
          <div class="vx-col w-full">
            <a role="button" class="cursor-pointer" @click="remove()">
              Remove
            </a>
          </div>
          <div class="vx-col w-full" v-if="canSetPrimary">
            <a
              v-if="data_local.primary"
              role="button"
              class="cursor-pointer primary"
            >
              Primary
            </a>

            <a
              v-if="!data_local.primary"
              role="button"
              class="cursor-pointer"
              @click="makePrimary()"
            >
              Set as Primary
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ValidationMessage from '../validation/ValidationMessage';
import vSelect from 'vue-select';

export default {
  name: 'AdditiveContactField',
  inject: ['$validator'],
  components: {
    ValidationMessage,
    vSelect
  },
  props: {
    validationName: {
      type: String
    },
    validationType: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    canSetPrimary: {
      type: Boolean,
      required: false,
      default: false
    },
    secondarySelectOptions: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    },
    additionalInput: {
      type: Boolean,
      required: false,
      default: false
    },
    primaryInputValidationName: {
      type: String
    },
    primaryInputValidationType: {
      type: String,
      default: ''
    },
    primarySelectValidationName: {
      type: String
    },
    primarySelectValidationType: {
      type: String,
      default: ''
    },
    additionalInputValidationName: {
      type: String
    },
    additionalInputValidationType: {
      type: String,
      default: ''
    },
    secondarySelectValidationName: {
      type: String
    },
    secondarySelectValidationType: {
      type: String,
      default: ''
    },
    secondaryInputValidationName: {
      type: String
    },
    secondaryInputValidationType: {
      type: String,
      default: ''
    },
    dropdownLabel: {
      type: String
    },
    primaryInputLabel: {
      type: String
    },
    secondarySelectLabel: {
      type: String
    },
    secondaryInputLabel: {
      type: String
    },
    additionalInputLabel: {
      type: String
    }
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.value))
    };
  },
  computed: {
    id() {
      return this.data_local.id - 1;
    },
    primary_dropdown_local: {
      get() {
        const value = this.options.find(
          item => item.value === parseInt(this.data_local.dropdownValue)
        );

        return value;
      },
      set(val) {
        this.data_local.dropdownValue = val.value;
      }
    },
    secondary_dropdown_local: {
      get() {
        const value = this.secondarySelectOptions.find(
          item => item.value === this.data_local.secondaryValue
        );
        return value;
      },
      set(val) {
        this.data_local.secondaryValue = val.value;
      }
    },
    actionsLabel() {
      if (
        this.dropdownLabel ||
        this.primaryInputLabel ||
        this.secondaryInputLabel ||
        this.secondarySelectLabel ||
        this.additionalInputLabel
      ) {
        return true;
      }
      return false;
    }
  },
  watch: {
    data_local: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    hideFieldName(field) {
      const error = this.vErrors.first(field);

      if (!error) {
        return error;
      }

      return error.replace(field, '');
    },
    remove() {
      this.$emit('remove');
    },
    makePrimary() {
      this.$emit('makePrimary');
    }
  },
  created() {
    this.inputInstances = this.value;
  }
};
</script>

<style lang="scss">
.action-buttons {
  a {
    font-size: 12px;

    &.primary {
      color: #666666;
      &:hover {
        text-decoration: none;
      }
    }
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
